<template>
  <div>
    <div class="col-sm-12">
      <el-table class="table table-striped table-no-bordered table-hover" ref="historyTable" :data="history"
        v-loading="paging" element-loading-spinner="qc-spinner" style="width: 100%" highlight-current-row
        @row-click="selectApplication" tooltip-effect="light">
        <el-table-column :width="70" v-if="checkboxCol == true">
          <template>
            <input type="checkbox">
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header">
            <span>Created</span>
            <el-tooltip
              content="Date application created."
              placement="top"
              effect="dark"
            >
              <i class="fa fa-info-circle info-icon"></i>
            </el-tooltip>
          </template>
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{formatDate(props.row.created)}}</span>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot="header">
            <span>Submitted</span>
            <el-tooltip
              content="Date the verification request was first submitted. If this date is earlier than the Created date, it means a verification request for the applicant was initiated before your application record was created."
              placement="top"
              effect="dark"
              popper-class="submitted-tooltip"
            >
              <i class="fa fa-info-circle info-icon"></i>
            </el-tooltip>
          </template>
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{props.row.submitted ? formatDate(props.row.submitted) : null}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="isIndividual" :show-overflow-tooltip="true">
          <template slot="header">
            <span>Organisation</span>
            <el-tooltip
              content="Organisation's name."
              placement="top"
              effect="dark"
            >
              <i class="fa fa-info-circle info-icon"></i>
            </el-tooltip>
          </template>
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{props.row.owner.name}}</span>
          </template>
        </el-table-column>
        <el-table-column v-else :show-overflow-tooltip="true">
          <template slot="header">
            <span>Applicant</span>
            <el-tooltip
              content="Applicant's name."
              placement="top"
              effect="dark"
            >
              <i class="fa fa-info-circle info-icon"></i>
            </el-tooltip>
          </template>
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{props.row.applicant.name}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="!isIndividual" :show-overflow-tooltip="true">
          <template slot="header">
            <span>
              Application Reference
            </span>
            <el-tooltip
              content="Application reference number."
              placement="top"
              effect="dark"
            >
              <i class="fa fa-info-circle info-icon"></i>
            </el-tooltip>
          </template>
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">
              {{ props.row.applicationReference || props.row.customerReference || '' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" :show-overflow-tooltip="true">
          <template slot="header">
            <span>Status</span>
            <el-tooltip
              content="Current status of the verification."
              placement="top"
              effect="dark"
            >
              <i class="fa fa-info-circle info-icon"></i>
            </el-tooltip>
          </template>
          <template slot-scope="props">
            <span v-if="props.row.status == 'OPEN'" class="label label-wd label-plain text-plain"><i class="fa fa-pencil"></i>Open</span>
            <span v-else-if="props.row.status == 'PENDING'" class="label label-wd label-plain"><i class="fa fa-clock-o"></i>Pending</span>
            <span v-else-if="props.row.status == 'APPLICANT_ACTION'" class="label label-wd label-plain"><i class="fa fa-clock-o"></i>Pending<br /><span style="font-size: 80%;">(Applicant Action Required)</span></span>
            <span v-else-if="props.row.status == 'COMPLETED'" class="font-weight-bold label label-wd label-plain text-success">
              <i class="fa fa-check text-success"></i>Completed
              <br />
              <span style="font-size: 80%;">({{formatDate(props.row.completed)}})</span>
              <span class="insight-tag" v-if="hasInsights(props.row.insight)">
                <br />
                <i class="fa fa-exclamation"></i>Insights
              </span>
            </span>
            <span v-else-if="props.row.status == 'ARCHIVED'" class="label label-wd label-plain"><i class="fa fa-folder-open-o"></i>Archived</span>
            <span v-else>{{props.row.result}}</span>
          </template>
        </el-table-column>
        <el-table-column :min-width="60" fixed="right" align="right" :show-overflow-tooltip="true">
          <template slot="header">
            <span>Verifications</span>
            <el-tooltip
              content="Number of verifications for this applicant."
              placement="top"
              effect="dark"
            >
              <i class="fa fa-info-circle info-icon"></i>
            </el-tooltip>
          </template>
          <template slot-scope="props">
            <span :class="{'font-weight-bold': props.row.status == 'COMPLETED'}">{{props.row.verificationCount}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="showPagination" class="col-sm-6 pagination-info">
      <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
    </div>
    <div v-if="showPagination" class="col-sm-6">
      <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
        :total="pagination.total">
      </p-pagination>
    </div>
  </div>
</template>
<script>

import PPagination from 'src/components/Pagination.vue'

import moment from 'moment'
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'
import EventBus from '../../../bus'
import {INSIGHT_TYPE} from "@/utils/noticeType";

export default {
  name: "application-history-table",
  components: {
    PPagination
  },
  props: {
    query: { type: String, default: "" },
    status: { type: Array, default: () => { return [] } },
    dateRange: { type: Array, default: () => { return [] } },
    customFilters: { type: Array, default: () => { return [] } },
    customerReference: { type: String, default: "" },
    size: { type: Number, default: 20 },
    showPagination: { type: Boolean, default: true },
    templateId: { type: [String, Number], default: null }
  },
  data() {
    return {
      result: null,
      history: null,
      paging: false,
      checkboxCol: false,
      total: 0,
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
    }
  },
  mounted() {
    this.getHistory()
    this.checkboxCol = false
    this.$store.state.applicantSelectedRows = []
  },
  activated() {
    this.getHistory()
  },
  watch: {
    applicantCheckboxStatus: function (val) {
      this.checkboxCol = val
    },
    reloadApplicantHistoryTable: function (val) {
      if(val == true) {
        this.getHistory()
        this.$store.state.reloadApplicantHistoryTable = false
        this.$store.state.applicantCheckboxArchive = false
      }
    },
    query: _.debounce(function (value) {
      this.pagination.currentPage = 1
      this.getHistory()
    }, 500),
    templateId(value) {
      this.pagination.currentPage = 1
      this.getHistory()
    },
    status(value) {
      this.pagination.currentPage = 1
      this.getHistory()
    },
    customerReference(value) {
      this.pagination.currentPage = 1
      this.getHistory()
    },
    dateRange(value) {
      this.pagination.currentPage = 1
      this.getHistory()
    },
    paginationCurrentPage(value) {
      this.getHistory()
    },
    paginationPerPag(value) {
      this.getHistory()
    }
  },
  computed: {
    ...mapState(["applicantCheckboxArchive", "reloadApplicantHistoryTable"]),
    ...mapGetters({
      applicantCheckboxStatus: 'getApplicantCheckboxArchive',
      reloadApplicantHistoryTable: 'getReloadApplicantHistoryTable'
    }),
    paginationCurrentPage() {
      return this.pagination.currentPage
    },
    paginationPerPag() {
      return this.pagination.perPage
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    isIndividual() {
      return this.$store.state.isIndividual
    }
  },
  methods: {
    hasInsights(rowData) {
      let filteredInsights = []
      if(rowData.length > 0) {
        filteredInsights = rowData.filter(insight => {
          if (insight.type === INSIGHT_TYPE.DETAILS || !insight.isMatch) {
            return insight
          }
        })
      }
      return filteredInsights.length > 0
    },
    formatDate(timestamp) {
      var m = moment(timestamp)
      return m.format('DD MMM YYYY')
    },
    getHistory: _.debounce(function () {
      this.paging = true
      this.history = []
      let historyRequest = {
        page: this.pagination.currentPage - 1,
        size: this.size,
        query: this.query,
        status: this.status,
        fromDate: this.dateRange[0],
        toDate: this.dateRange[1],
        customerReference: this.customerReference,
        templateId: this.templateId === 'All' ? null : this.templateId,
      }
      this.$api.getApplicationHistory(historyRequest, this.customFilters)
        .then(response => {
          this.history = response.data.content
          this.pagination.total = response.data.totalSize
          this.total = response.data.totalSize
          this.paging = false
        })
        .catch(error => {
          this.paging = false
        })
    }, 500),
    selectApplication(row, column, event) {
      if (row && this.checkboxCol == false) {
        if (this.isIndividual) {
          this.$router.push('/application/history/' + row.id)
        } else {
          this.$router.push('/applicant/history/' + row.id)
        }
      } else if (event.target.type == "checkbox") {
        this.pushRowId(row)
      }
    },
    pushRowId(row) {
      if (this.$store.state.applicantSelectedRows.includes(row.id)) {
        this.$store.state.applicantSelectedRows.splice(this.$store.state.applicantSelectedRows.indexOf(row.id), 1)
      } else {
        this.$store.state.applicantSelectedRows.push(row.id)
      }
    }
  }
}
</script>
<style>
  .insight-tag {
    color: orange;
  }

  .fa-exclamation {
    margin-left: -10px;
  }

  .info-icon {
    margin-left: 6px;
    color: #999;
    cursor: pointer;
    font-size: 13px;
  }

  .info-icon:hover {
    color: #409EFF; /* Element UI primary color */
  }

  .submitted-tooltip {
    min-width: 250px;
    max-width: 280px;
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.4;
  }
</style>
